import React, { useState } from 'react';
import { Title, TitleProps } from '@gjensidige/builders-components';
import './InsurancePackageSmallScreen.scss';
import { Coverage, HeaderSmallScreen, HeaderTab } from '../../interfaces/Types';
import { CoverageList } from '../CoverageList/CoverageList';
import { InsuranceTileContentSmallScreen } from './InsuranceTileContent/InsuranceTileContentSmallScreen';
import { InsuranceTileHeaderSmallScreen } from './InsuranceTileHeader/InsuranceTileHeaderSmallScreen';
import { InsuranceTileSelectionTabs } from './InsuranceTileHeader/InsuranceTileSelectionTabs';
interface Props {
  selectionTabs: HeaderTab[];
  header?: HeaderSmallScreen | undefined;
  includedCoverages: Coverage[];
  excludedCoverages: Coverage[];
  isPackageSelected: boolean;
  disabledMessage?: string;
  isEnabled: boolean;
  /**
   * Handle side effects of updating the Tile selection
   */
  updateTileSelection: (packageCode: string) => void;
}

export type ComponentProps = Props;

const InsurancePackageSmallScreen: React.FC<Props> = ({
  selectionTabs,
  header,
  updateTileSelection,
  includedCoverages,
  excludedCoverages,
  isPackageSelected,
  isEnabled,
  disabledMessage
}: Props) => {
  return (
    <div className="insurance-container-small-screen">
      <InsuranceTileSelectionTabs
        selectionTabs={selectionTabs}
        updateTileSelection={updateTileSelection}
      />
      {isPackageSelected ? (
        <>
          <InsuranceTileHeaderSmallScreen header={header} />
          <InsuranceTileContentSmallScreen
            header={header}
            includedCoverages={includedCoverages}
            excludedCoverages={excludedCoverages}
            isEnabled={isEnabled}
            disabledMessage={disabledMessage}
          />
        </>
      ) :
        (
          <Title as={"h4" as TitleProps['as']} className="p-2">
            Välj ett paket ovan för att läsa mer
          </Title>
        )}
    </div>
  );
};
export default InsurancePackageSmallScreen;
